import { render, staticRenderFns } from "./DevappDetails.vue?vue&type=template&id=2d6671f8&scoped=true"
import script from "./DevappDetails.vue?vue&type=script&lang=js"
export * from "./DevappDetails.vue?vue&type=script&lang=js"
import style0 from "./DevappDetails.vue?vue&type=style&index=0&id=2d6671f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6671f8",
  null
  
)

export default component.exports